















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import _ from "lodash";

interface Insertion {
    proofValidated: boolean;
    proofs: any[];
}

@Component({components: {SimpleText}})
export default class Documents extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.proofValidated",
            "insertion.proofs.uuid",
            "insertion.invoiceLines.invoice.documents.uuid",
        ];
    }

    private get hasShowableDocuments() {
        if (this.insertion.proofValidated) {
            return true;
        }

        for (const invoiceLine of _.get(this.insertion, "invoiceLines", [])) {
            const invoice = _.get(invoiceLine, "invoice", null);
            if (invoice && _.get(invoice, "documents", []).length > 0) {
                return true;
            }
        }

        return false;
    }

    private showDocuments(uuid: string | null) {
        this.$emit("show-documents", {uuid});
    }
}
